import type { UUID } from '@/types/Id'

interface TagsQueryKeyArgs {
  orgId: UUID | ''
}

export const tagsQueryKeys = {
  all: () => ['tags'] as const,
  organization: (keyArgs: TagsQueryKeyArgs) => ['tags', keyArgs.orgId] as const,
}
